<template>
  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-users text-primary mr-2"></i>
          Gestión de No Socios
        </h4>
      </b-col>
    </b-row>

    <b-row md="12" class="pb-3">
      <b-col class="col-md-12">
        <b-row md="12">
          <b-card class="w-100">
            <b-row
              slot="header"
              class="m-0 p-0 justify-content-between align-items-center"
            >
              No Socios
              <div>
                <button
                  :disabled="count < 1"
                  class="btn btn-primary btn-sm mr-2"
                  @click="exportClients('csv')"
                >
                  <i class="fa fa-download"></i> CSV
                </button>
                <button
                  :disabled="count < 1"
                  class="btn btn-primary btn-sm"
                  @click="exportClients('xlsx')"
                >
                  <i class="fa fa-download"></i> Excel
                </button>
                <button
                  :disabled="count < 1"
                  class="btn btn-primary btn-sm ml-2"
                  @click="exportClients('pdf')"
                >
                  <i class="fa fa-download"></i> PDF
                </button>
              </div>
            </b-row>
            <b-row md="12" class="mb-3 border-top-primary px-2">
              <b-col class="col-md-5">
                <!-- ////////////////////// Buscar ////////////////////// !-->
                <b-form-group
                  label="Buscar"
                  :label-cols="3"
                  :horizontal="true"
                  class="w-100 mb-0"
                >
                  <b-form-input
                    id="string"
                    name="string"
                    type="text"
                    placeholder="Busqueda general"
                    v-model="entity.string"
                    class="w-100"
                    v-validate="'min:3'"
                    :state="validateState('string')"
                    aria-describedby="check_string"
                  ></b-form-input>
                  <div class="text-danger text-right" id="check_string">
                    <small>{{ errors.first("string") }}</small>
                  </div>
                </b-form-group>
                <!-- !-->
              </b-col>

              <b-col class="col-md-7">
                <button
                  class="btn btn-pill btn-primary ml-4 float-right"
                  @click="search"
                >
                  Buscar No Socio
                </button>
              </b-col>
            </b-row>

            <v-server-table
              :columns="columns"
              :options="options"
              :theme="theme"
              class="dataTable"
              ref="dataTable"
              md="12"
              lg="12"
              sm="12"
              @sorted="tableSorted"
            >
              <template slot="beforeBody">
                <tr v-if="loading">
                  <td class="text-center loading" colspan="7">
                    <spinner
                      size="medium"
                      line-fg-color="#025542"
                      line-bg-color="#c8ced3"
                    ></spinner>
                  </td>
                </tr>
              </template>
              <template slot="uuid" slot-scope="props">
                <button
                    v-b-tooltip.hover.top
                    title="Editar"
                    class="btn p-0"
                    @click="updateClientModal(props)">
                    <i class="fa fa-pencil"></i>
                </button>
                <button
                    v-b-tooltip.hover.top
                    title="Cambiar a Socio"
                    class="btn p-0 ml-1"
                    @click="changeClientModal(props)">
                    <i class="fa fa-user-plus"></i>
                </button>
              </template>
              <template slot="phones" slot-scope="props">
                <div v-if="!!props.row.phones">
                  <p
                    v-for="phone in props.row.phones"
                    :key="phone.uuid"
                    class="pl-1 mb-0">
                    {{ phone.phone }}
                  </p>
                </div>
              </template>
              <template slot="emails" slot-scope="props">
                <div v-if="!!props.row.emails">
                  <p
                    v-for="email in props.row.emails"
                    :key="email.uuid"
                    class="pl-1 mb-0">
                    {{ email.email }}
                  </p>
                </div>
              </template>
              <!--
              <template slot="emails" slot-scope="props">
                <div v-html="props.row.emails"></div>
              </template>
              -->
            </v-server-table>
          </b-card>

          <b-modal
            id="updateClientModal"
            ref="updateClientModal"
            title="Editar No Socio"
            hide-footer
            centered
          >
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>NIF</strong>"
                label-for="nif"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="nif"
                  name="nif"
                  type="text"
                  placeholder="NIF"
                  v-model="selectedClient.row.nif"
                  class="w-100"
                  v-validate="'required|min:9'"
                  :state="validateState('nif')"
                  aria-describedby="check_nif"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_nif">
                  <small>{{ errors.first("nif") }}</small>
                </div>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Nombre</strong>"
                label-for="name"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Nombre"
                  v-model="selectedClient.row.name"
                  class="w-100"
                  v-validate="'required|min:3'"
                  :state="validateState('name')"
                  aria-describedby="check_name"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_name">
                  <small>{{ errors.first("name") }}</small>
                </div>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Apellidos</strong>"
                label-for="surname"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="surname"
                  name="surname"
                  type="text"
                  placeholder="Apellido"
                  v-model="selectedClient.row.surname"
                  class="w-100"
                  v-validate="'required|min:3'"
                  :state="validateState('surname')"
                  aria-describedby="check_surname"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_surname">
                  <small>{{ errors.first("surname") }}</small>
                </div>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Sexo *</strong>"
                label-for="sex"
                label-cols="4"
                :horizontal="false"
                class="w-100 mb-0">
                <multiselect
                  name="sex"
                  v-model="selectedClient.row.sex"
                  :options="sex.map(type => type.uuid)"
                  :custom-label="opt => sex.find(x => x.uuid == opt).name"
                  :multiple="false"
                  :allowEmpty="false"
                  placeholder="Seleccione"
                  selectLabel="+"
                  deselectLabel="-"
                  v-if="sex">
                </multiselect>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>F. de Nacimiento</strong>"
                label-for="partnerBirthdate"
                label-cols="4"
                :horizontal="false"
                class="w-100  mb-0">
                <v-date-picker v-model="entityBirthdayFormatted" :max-date="new Date()" popoverDirection="top">
                  <template v-slot="{ inputValue, inputEvents }">
                    <b-form-input
                      :value="inputValue"
                      v-on="inputEvents"
                      @change="changeBirthday"
                      id="partnerBirthdate"
                      name="partnerBirthdate"
                      class="w-100"
                      v-validate="'partnerBirthdate'"
                      :state="validateState('partnerBirthdate')"
                      aria-describedby="check_partnerBirthdate" />
                  </template>
                </v-date-picker>
              </b-form-group>
              <div class="text-danger text-right" id="check_partnerBirthdate">
                <small>{{ errors.first('partnerBirthdate') }}</small>
              </div>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Teléfonos</strong>"
                label-for="phone"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="phone"
                  name="phone"
                  type="text"
                  placeholder="Teléfono"
                  class="w-100"
                  @keypress.enter.native="addPhone($event.target.value)"
                  :state="validateState('phone')"
                  aria-describedby="check_phone"
                  v-model="phone"
                  autocomplete="nope"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_phone">
                  <small>{{ errors.first("phone") }}</small>
                </div>
                <b-list-group>
                  <b-list-group-item
                    v-for="(phone,index) in selectedClient.row.phones"
                    :key="index">{{ phone.phone }}
                    <div @click="removePhone(phone.phone)">
                      <template>
                        <b-badge
                          variant="danger"
                          class="float-left"
                          pill>Borrar
                        </b-badge>
                      </template>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Emails</strong>"
                label-for="email"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="email"
                  name="email"
                  type="text"
                  placeholder="Email"
                  class="w-100"
                  @keypress.enter.native="addEmail($event.target.value)"
                  v-validate="'email'"
                  :state="validateState('email')"
                  aria-describedby="check_email"
                  v-model="email"
                  autocomplete="nope"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_email">
                  <small>{{ errors.first("email") }}</small>
                </div>
                <b-list-group>
                  <b-list-group-item
                    v-for="(email, index) in selectedClient.row.emails"
                    :key="index">{{ email.email }}
                    <template v-if="email.main">
                      <b-badge
                        variant="primary"
                        class="float-right"
                        pill>Principal
                      </b-badge>
                    </template>
                    <template v-else>
                      <b-badge
                        variant="secondary"
                        class="float-right"
                        pill>Secundario
                      </b-badge>
                    </template>

                    <div @click="changeEmailStatus(email.email)">
                      <template v-if="email.status == 'ACTIVE'">
                        <b-badge
                          variant="success"
                          class="float-right"
                          pill>ACTIVO
                        </b-badge>
                      </template>
                      <template v-else-if="email.status == 'UNWANTED'">
                        <b-badge
                          variant="warning"
                          class="float-right"
                          pill>NO DESEA
                        </b-badge>
                      </template>
                      <template v-else>
                        <b-badge
                          variant="danger"
                          class="float-right"
                          pill>ERRONEO
                        </b-badge>
                      </template>
                    </div>
                    <div @click="removeEmail(email.email)">
                      <template>
                        <b-badge
                          variant="danger"
                          class="float-left"
                          pill>Borrar
                        </b-badge>
                      </template>
                    </div>

                  </b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <location-form
              v-if="modal"
              :community-required="false"
              :province-required="true"
              :initial-community="selectedClient.row.address.community"
              :initial-province="selectedClient.row.address.province"
              :initial-town="selectedClient.row.address.town"
              :initial-postal-code="(selectedClient.row.address.postalCode != undefined && selectedClient.row.address.postalCode != null) ? parseInt(selectedClient.row.address.postalCode) : 0"
              :initial-address="selectedClient.row.address.address"
              @community-change="community => {selectedClient.row.address.community = community}"
              @province-change="province => {selectedClient.row.address.province = province}"
              @town-change="town => {selectedClient.row.address.town = town}"
              @postal-code-change="postalCode => {selectedClient.row.address.postalCode = postalCode}"
              @address-change="address => {selectedClient.row.address.address = address}"></location-form>
            </b-row>
            <b-row
              class="
                border-top
                pt-3
                px-3
                flex-row-reverse
                align-content-between
                mt-4
              "
            >
              <button
                class="btn btn-brand btn-primary btn-lg float-right"
                @click="updateClient"
              >
                Guardar
              </button>
            </b-row>
          </b-modal>

          <b-modal
            id="changeClientModal"
            ref="changeClientModal"
            title="Cambiar a Socio"
            hide-footer
            centered
          >
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>NIF</strong>"
                label-for="nif"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="nif"
                  name="nif"
                  type="text"
                  placeholder="NIF"
                  v-model="selectedClient.row.nif"
                  class="w-100"
                  v-validate="'min:3'"
                  :state="validateState('nif')"
                  aria-describedby="check_nif"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_nif">
                  <small>{{ errors.first("nif") }}</small>
                </div>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Nombre</strong>"
                label-for="name"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Nombre"
                  v-model="selectedClient.row.name"
                  class="w-100"
                  v-validate="'required|min:3'"
                  :state="validateState('name')"
                  aria-describedby="check_name"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_name">
                  <small>{{ errors.first("name") }}</small>
                </div>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Apellidos</strong>"
                label-for="surname"
                :horizontal="false"
                class="w-100 mb-0"
              >
                <b-form-input
                  id="surname"
                  name="surname"
                  type="text"
                  placeholder="Apellido"
                  v-model="selectedClient.row.surname"
                  class="w-100"
                  v-validate="'required|min:3'"
                  :state="validateState('surname')"
                  aria-describedby="check_surname"
                >
                </b-form-input>
                <div class="text-danger text-right" id="check_surname">
                  <small>{{ errors.first("surname") }}</small>
                </div>
              </b-form-group>
            </b-row>
            <b-row class="mt-2 mx-5">
              <b-form-group
                label="<strong>Sede</strong>"
                label-for="headquartersId"
                :horizontal="false"
                class="w-100"
              >
                <multiselect
                  :allowEmpty="false"
                  :custom-label="
                    (opt) => headquarters.find((x) => x.uuid == opt).name
                  "
                  :multiple="false"
                  :options="headquarters.map((type) => type.uuid)"
                  deselectLabel="-"
                  name="headquartersId"
                  placeholder="Seleccione"
                  selectLabel="+"
                  v-if="headquarters"
                  v-model="selectedClient.row.headquartersId"
                >
                </multiselect>
              </b-form-group>
            </b-row>
            <b-row
              class="
                border-top
                pt-3
                px-3
                flex-row-reverse
                align-content-between
                mt-4
              "
            >
              <button
                class="btn btn-brand btn-primary btn-lg float-right"
                @click="changeClient"
              >
                Guardar
              </button>
            </b-row>
          </b-modal>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
import { setupCalendar, DatePicker } from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import form from "@/helpers/form";
import { ServerTable, Event } from "vue-tables-2";
import { downloadJsonAsCsv, downloadJsonAsXlsx } from "@/helpers/js-xlsx";
import { downloadJsonAsPdf } from "@/helpers/js-pdf";
import LocationForm from '@/components/location/LocationForm';
import headquartersSelector from "@/components/headquarters/HeadquartersSelector";
import Spinner from "vue-simple-spinner";
import { request } from "@/helpers/services";
import moment from "moment";

Vue.use(ServerTable);

setupCalendar({
  firstDayOfWeek: 2, // Monday
});

export default {
  name: "listNoPartners",
  components: {
    "v-date-picker": DatePicker,
    Multiselect,
    LocationForm,
    headquartersSelector,
    Spinner,
  },
  data: function () {
    return {
      topmenu: [
        {
          name: "Inicio",
          path: "/admin/dashboard",
          brand: "fa fa-home",
        },
      ],
      entity: {
        string: null,
        page: 1,
        itemsPerPage: 10,
      },
      orderBy: {
        column: null,
        ascending: null,
      },
      modal: false,
      client: null,
      provinces: null,
      headquarters: [],
      sex: [
        {uuid: 1, name: 'Hombre'},
        {uuid: 2, name: 'Mujer'},
        {uuid: 3, name: 'Otra identidad'},
      ],
      selectedClient: {
        row: {
          uuid: null,
          name: null,
          surname: null,
          sex: null,
          birthday: null,
          nif: null,
          phones: [],
          emails: [],
          address: {
            name: null,
            address: null,
            town: null,
            postalCode: null,
            province: null,
            community: null,
            main: true
          },
          headquartersId: null
        }
      },
      email: '',
      phone: '',
      count: 0,
      loading: true,
      options: {
        headings: {
          uuid: {
            text: "",
            id: "fit",
          },
          name: "Nombre",
          surname: "Apellidos",
          phones: "Teléfonos",
          emails: "Emails"
        },
        requestFunction: (data) => {
          if (this.$store.getters.getFilters[0] !== null) {
            this.entity.string = this.$store.getters.getFilters[0];
          }
          this.entity.page = data.page;
          this.entity.itemsPerPage = data.limit;
          let self = this;
          return axios({
            url: "clients/",
            method: "get",
            params: this.searchFilters,
          }).catch(
            function (e) {
              self.dispatch("error", e);
            }.bind(this)
          );
        },
        responseAdapter: ({ data }) => {
          return {
            data: data.clients,
            count: data.count,
          };
        },
        columnsClasses: { uuid: "fit" },
        sortable: ["name", "surname", "phones", "emails"],
        filterable: false,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        perPageValues: [10, 25, 50, 100, 500, 1000],
        texts: form.tableLabels(),
        pagination: {
          chunk: 10,
          edge: true,
          nav: "scroll",
        },
      },
      columns: ["uuid", "name", "surname", "phones", "emails"],
      useVuex: false,
      theme: "bootstrap4",
      template: "default"
    };
  },
  mounted() {
    this.requests("headquarters", "get", 200, "headquarters");

    this.$_loadingMixin_showLoading();
    // vue-tables events
    Event.$on("vue-tables.loading", (data) => {
      this.$_loadingMixin_showLoading();
      this.count = 0;
      this.loading = true;
      //this.$refs.dataTable.data = [];
      if (!!document.querySelector(".VueTables__no-results")) {
        document.querySelector(".VueTables__no-results").style.display = "none";
      }
    });
    Event.$on("vue-tables.loaded", (data) => {
      if (!!data && !!data.data && !!data.data.count) {
        this.count = data.data.count;
      }
      this.$_loadingMixin_hideLoading();
      this.loading = false;
      if (!!document.querySelector(".VueTables__no-results")) {
        document.querySelector(".VueTables__no-results").style.display =
          "table-row";
      }
    });

    this.$eventHub.$emit("captureMenu", this.topmenu);
  },
  computed: {
    searchFilters() {
      return {
        string: this.entity.string,
        page: this.entity.page,
        itemsPerPage: this.entity.itemsPerPage,
        orderColumn: this.orderBy.column,
        orderAscending: this.orderBy.ascending ? 1 : 0,
      };
    },
    entityBirthdayFormatted: {
      get() {
        if(!this.selectedClient.row.birthday) return null;
        return new Date(this.selectedClient.row.birthday);
      },
      set(newValue) {
        if(!newValue || newValue === "") {
          this.selectedClient.row.birthday = null;
          return;
        }
        this.selectedClient.row.birthday = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    },
  },
  methods: {
    async requests(path, method, okCode, entity, data = null) {
      this.$_loadingMixin_showLoading();
      this[entity] = await request(path, method, okCode, data);
      this.$_loadingMixin_hideLoading();

      return this[entity];
    },
    async readProvinces() {
      try {
        return await this.requests(
          "provinces",
          "get",
          200,
          "provinces"
        );
      } catch (error) {
        this.$_loadingMixin_hideLoading();

        this.$_notificationMixin_error(
          "Operación no completada",
          "Ocurrio un error al obtener las provincias"
        );
      }
    },
    async readClient(clientId) {
      try {
        return await this.requests(
          `clients/${clientId}`,
          "get",
          200,
          "clients"
        );
      } catch (error) {
        this.$_loadingMixin_hideLoading();

        this.$_notificationMixin_error(
          "Operación no completada",
          "Ocurrio un error al obtener el no socio"
        );
      }
    },
    async updateClient() {
      try {
        if (
          !this.selectedClient.row.address.province
          ||
          !this.selectedClient.row.address.town
          ||
          !this.selectedClient.row.address.postalCode
          ||
          !this.selectedClient.row.address.main
        ) {
          this.selectedClient.row.address = null;
        }

        if (this.validateState('phone')) {
          this.addPhone(this.phone);
        }

        if (this.validateState('email')) {
          this.addEmail(this.email);
        }

        await this.requests(
          `clients/${this.selectedClient.row.uuid}`,
          "post",
          200,
          "clients",
          this.selectedClient.row
        );

        this.selectedClient.row.address = {
          name: null,
          address: null,
          town: null,
          postalCode: null,
          province: null,
          community: null,
          main: true
        };

        this.$refs.dataTable.refresh();
        this.$_notificationMixin_success('Operación completada', 'El no socio ha sido actualizado');
        this.$refs.updateClientModal.hide();
      } catch (error) {
        this.$_loadingMixin_hideLoading();

        this.$_notificationMixin_error(
          "Operación no completada",
          "Ocurrio un error al actualizar el no socio"
        );
      }
    },
    async updateClientModal(item) {
      this.modal = false;

      this.client = await this.readClient(item.row.uuid);

      this.selectedClient.row.uuid = null;
      this.selectedClient.row.nif = null;
      this.selectedClient.row.name = null;
      this.selectedClient.row.surname = null;
      this.selectedClient.row.sex = null;
      this.selectedClient.row.birthday = null;
      this.selectedClient.row.phones = [];
      this.selectedClient.row.emails = [];
      this.selectedClient.row.address.name = null;
      this.selectedClient.row.address.community = null;
      this.selectedClient.row.address.province = null;
      this.selectedClient.row.address.town = null;
      this.selectedClient.row.address.postalCode = null;
      this.selectedClient.row.address.address = null;
      this.selectedClient.row.address.main = true;

      if (this.client.uuid) {
        this.selectedClient.row.uuid = this.client.uuid;
      }
      if (this.client.nif) {
        this.selectedClient.row.nif = this.client.nif;
      }
      if (this.client.name) {
        this.selectedClient.row.name = this.client.name;
      }
      if (this.client.surname) {
        this.selectedClient.row.surname = this.client.surname;
      }
      if (this.client.sex) {
        this.selectedClient.row.sex = this.client.sex;
      }
      if (this.client.birthday) {
        this.selectedClient.row.birthday = this.client.birthday;
      }
      if (this.client.phones) {
        this.selectedClient.row.phones = this.client.phones;
      }
      if (this.client.emails) {
        this.selectedClient.row.emails = this.client.emails;
      }
      if (this.client.address) {
        this.provinces = await this.readProvinces();

        for (var i = 0; i < this.provinces.length; i++) {
          if (this.client.address.province == this.provinces[i].name) {
            this.client.address.community = this.provinces[i].community.name;
          }
        }

        this.selectedClient.row.address = this.client.address;
      }

      this.modal = true;
      this.$refs.updateClientModal.show();
    },
    async changeClient() {
      try {
        await this.requests(
          `clients/${this.selectedClient.row.uuid}/change`,
          "post",
          200,
          "clients",
          this.selectedClient.row
        );
        this.$router.push({ path: '/partners/accounts/edit/' + this.selectedClient.row.uuid});
      } catch (error) {
        this.$_loadingMixin_hideLoading();

        this.$_notificationMixin_error(
          "Operación no completada",
          "Ocurrio un error al convertir en socio"
        );
      }
    },
    async changeClientModal(item) {
      this.client = await this.readClient(item.row.uuid);

      this.selectedClient.row.uuid = null;
      this.selectedClient.row.nif = null;
      this.selectedClient.row.name = null;
      this.selectedClient.row.surname = null;
      this.selectedClient.row.sex = null;
      this.selectedClient.row.birthday = null;
      this.selectedClient.row.headquartersId = null;

      if (this.client.uuid) {
        this.selectedClient.row.uuid = this.client.uuid;
      }
      if (this.client.nif) {
        this.selectedClient.row.nif = this.client.nif;
      }
      if (this.client.name) {
        this.selectedClient.row.name = this.client.name;
      }
      if (this.client.surname) {
        this.selectedClient.row.surname = this.client.surname;
      }
      if (this.client.sex) {
        this.selectedClient.row.sex = this.client.sex;
      }
      if (this.client.birthday) {
        this.selectedClient.row.birthday = this.client.birthday;
      }
      if (this.client.headquartersId) {
        this.selectedClient.row.headquartersId = this.client.headquartersId;
      }

      this.$refs.changeClientModal.show();
    },
    search() {
      let filterData = [];
      filterData.push(this.entity.string);
      this.$store.commit('SET_FILTERS_LIST', filterData);
      this.$refs.dataTable.refresh();
    },
    validate() {
      // FIXME
      return true;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      } else {
        return null;
      }
    },
    async exportClients(format) {
      if (this.count > 0) {
        this.$_loadingMixin_showLoading();

        let response = await axios({
          method: "get",
          url: "clients",
          params: {
            page: 1,
            itemsPerPage: this.entity.itemsPerPage,
            string: this.entity.string,
          },
        });

        let self = this;
        let rows = response.data.clients.map(function (client) {
          return self.normalizeCLient(client);
        });

        if (format === "csv") {
          downloadJsonAsCsv(rows);
        } else if (format === "xlsx") {
          downloadJsonAsXlsx(rows);
        } else if (format === "pdf") {
          downloadJsonAsPdf(rows);
        }

        this.$_loadingMixin_hideLoading();
      }
    },
    tableSorted(data) {
      this.orderBy.column = data.column;
      this.orderBy.ascending = data.ascending;
    },
    changeBirthday(value) {
      this.entityBirthdayFormatted = value;
    },
    addPhone(number) {
      if (form.phone(number)) {
        this.selectedClient.row.phones.push({phone: number})
        this.phone = ""
      }
    },
    addEmail(emailVal) {
      let email2 = {
        email: '',
        status: '',
        main: false
      };

      if (form.email(emailVal)) {
        if (this.selectedClient.row.emails.length == 0) {
          email2.email = emailVal;
          email2.main = true;
          email2.status = 'ACTIVE';
        } else {
          email2.email = emailVal;
          email2.main = false;
          email2.status = 'ACTIVE';
        }
        this.selectedClient.row.emails.push(email2);
        this.email = null;
      }
    },
    changeEmailStatus(email) {
      this.selectedClient.row.emails.find(e => {
        if (e.email == email) {
          switch (e.status) {
            case 'ACTIVE':
              e.status = 'UNWANTED';
              break;
            case 'UNWANTED':
              e.status = 'WRONG';
              break;
            default:
              e.status = 'ACTIVE';
          }
          return e
        }
      });
    },
    removeEmail(email) {
      this.selectedClient.row.emails = this.selectedClient.row.emails.filter(function (e) {
        return e.email !== email;
      })
    },
    removePhone(phone) {
      this.selectedClient.row.phones = this.selectedClient.row.phones.filter(function (e) {
        return e.phone !== phone;
      })
    },
  },
};
</script>

<style lang="scss">
.VueTables__no-results {
  display: none;
}
</style>
